<template>
  <div class="subcategory-list">
    <router-link
      v-for="category in subCategories"
      :key="category?.id"
      :to="`/${category?.RootCategory?.slug}/${category?.slug}`"
      class="subcategory-chip"
    >
      {{ category?.categoryName }}
    </router-link>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    subCategories: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      isMobile: "isMobile",
    }),
  },
};
</script>

<style scoped lang="scss">
.subcategory-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 8px 10px;
}

.subcategory-chip {
  display: inline-flex;
  align-items: center;
  padding: 7px 18px;
  border-radius: 30px;
  border: 1px solid rgba($primaryColor, 0.45);
  background: #ffffff;
  color: $iconColor;
  font-family: Heebo;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.02em;
  text-decoration: none;
  white-space: nowrap;
  transition:
    background 0.25s ease,
    color 0.25s ease,
    border-color 0.25s ease,
    box-shadow 0.25s ease,
    transform 0.25s ease;

  &:hover,
  &:focus-visible {
    background: $primaryColor;
    border-color: $primaryColor;
    color: #ffffff;
    box-shadow: 0 4px 10px rgba($primaryColor, 0.35);
    transform: translateY(-2px);
  }

  &:active {
    transform: translateY(0);
  }
}

.isMobile,
.isTablet {
  .subcategory-chip {
    padding: 6px 14px;
    font-size: 12px;
  }
}
</style>
